import React from 'react';
import { agentIcon } from '../../../types/iconRegistry';
import { formatDistanceToNow } from 'date-fns';

// "Agent X decided to run Y because Z" ledger (T7.4).
function AutonomyLogView({ ledger = [] }) {
  return (
    <section className="ledger-card">
      {ledger.map((entry) => {
        const AgentIcon = agentIcon(entry.agentIcon);

        return (
          <article className="ledger-item" key={entry.id}>
            <span className="ledger-icon"><AgentIcon /></span>
            <div className="ledger-body">
              <strong>
                Agent {entry.agentName} decided to {entry.decision}{' '}
                <em>“{entry.jobTitle}”</em>
              </strong>
              <p>{entry.reason}</p>
            </div>
            <span className={`ledger-badge decision-${entry.decision}`}>
              {entry.decision}
            </span>
            <time className="ledger-time">
              {formatDistanceToNow(Date.now() - entry.minutesAgo * 60000, { addSuffix: true })}
            </time>
          </article>
        );
      })}
    </section>
  );
}

export default AutonomyLogView;
